export function getCourtCasesTablePath() {
  return `/gerichtsfaelle`
}
